import { render, staticRenderFns } from "./NotificationCardActivityPanel.vue?vue&type=template&id=7d586d5c&scoped=true&"
import script from "./NotificationCardActivityPanel.vue?vue&type=script&lang=js&"
export * from "./NotificationCardActivityPanel.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCardActivityPanel.vue?vue&type=style&index=0&id=7d586d5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d586d5c",
  null
  
)

export default component.exports